import { Grid, Tabs, Tab, Toolbar as MuiToolbar } from "@material-ui/core";
import { DateRange, AccessTime } from "@material-ui/icons";
import { Dispatch, SetStateAction, useCallback } from "react";
import { toolbarStyles } from "./toolbarStyles";
import { TimeButtons } from "./TimeButtons";
import { DateButtons } from "./DateButtons";
import { MeridiemButtons } from "./MeridiemButtons";

type ToolbarProps = {
  setCalendarType: Dispatch<SetStateAction<"date" | "year">>;
  setType: Dispatch<SetStateAction<"hours" | "minutes" | "seconds">>;
  setCurrentTab: Dispatch<SetStateAction<number>>;
  date: Date;
  currentTab: any;
  setDate: Dispatch<SetStateAction<Date>>;
};

export const Toolbar = ({
  date,
  currentTab,
  setCurrentTab,
  setCalendarType,
  setType,
  setDate,
}: ToolbarProps) => {
  const classes = toolbarStyles();
  const handleChangeType = useCallback(
    (type: "hours" | "minutes" | "seconds") => {
      setType(type);
      if (currentTab !== 1) setCurrentTab(1);
    },
    [currentTab, setType, setCurrentTab]
  );

  const handleChangeCalendarType = (type: "date" | "year") => {
    setCalendarType(type);
    if (currentTab !== 0) setCurrentTab(0);
  };
  return (
    <MuiToolbar className={classes.toolbar}>
      <Grid container className={classes.gridContainer}>
        <DateButtons
          onChangeCalendarType={handleChangeCalendarType}
          date={date}
        />
        <TimeButtons date={date} onChangeType={handleChangeType} />
        <MeridiemButtons date={date} onChangeDate={setDate} />
      </Grid>
      <Tabs
        style={{ width: "100%" }}
        value={currentTab}
        onChange={(_, newValue: number) => setCurrentTab(newValue)}
      >
        <Tab className={classes.tabControl} value={0} label={<DateRange />} />
        <Tab className={classes.tabControl} value={1} label={<AccessTime />} />
      </Tabs>
    </MuiToolbar>
  );
};
